import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string().min(1),
  }),
  response: z.void(),
};
